import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderSelectField from "../../../../shared/components/form/Select";
import $ from "jquery";
import XLSX from "xlsx";
import { make_cols } from "./MakeColumns";
import * as FileSaver from "file-saver";
import LoadingOverlay from 'react-loading-overlay';
import API from '../../../Common/api';

import "./styles.css";
import { rgbToHex } from "@material-ui/core";

var url = window.location.hostname;
var port = window.location.port;

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = (csvData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    //handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);

    this.accessCookie = this.accessCookie.bind(this);
    this.change = this.change.bind(this);
    // this.fetchBinData = this.fetchBinData.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
    this.ConfirmToggle = this.ConfirmToggle.bind(this);
    this.openConfirm = this.openConfirm.bind(this);

    this.state = {
      loading_overlay: false,
      supplier_invoice_header: [
        {
          "Product Condition" : "", 
          "Bin ID" : "",
          "Product Code":"",
          "MRP":"",
          "Return Qty":"",
          "Return Rate":"",
          "PO" : "",
          "Invoice":""
        },
      ],
      without_invoice_header: [
        {
          "Product Condition" : "", 
          "Bin ID" : "",
          "Product Code":"",
          "MRP":"",
          "Return Qty":"",
          "Return Rate":"",
        },
      ],
      validation: {

        "Without Invoice": {
          "Product Condition" : "string", 
          "Bin ID" : "string",
          "Product Code":"string",
          "MRP":"number",
          "Return Qty":"number",
          "Return Rate":"number",
          
        },
      "With Supplier Invoice": {
          "Product Condition" : "string", 
          "Bin ID" : "string",
          "Product Code":"string",
          "MRP":"number",
          "Return Qty":"number",
          "Return Rate":"number",
          "PO" : "string",
          "Invoice":"string"
        }
      },
      showPassword: false,
      responseModal: false,
      responseModalMsg: null,
      btnDisabled: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem: false,
      showInvalidProductItem: false,
      fileNameVal: "masterFile",
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: {},
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,

      isLoading: true,
      showFetchBinData: false,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      showWithoutInvoiceHeader: true,
      showWithInvoiceHeader: false,
      responseSuccessData : '',
      responseFailedData : ''
      
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  responseModalToggle = () => {
    this.setState({
      responseModal: !this.state.responseModal
    });
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: location,
      },
      () => {
      }
    );

    localStorage.setItem("userName", username);
  }



  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccesstoggleCancel() {
    this.setState(
      {
        Successmodal: false,
      }
    );

  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1(){
      window.location.href = "/receiving/confirm_saleable"
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  ConfirmToggle() {
    this.setState((prevState) => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm() {
    this.setState({
      ConfirmModal: true,
    });
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  handleChange(evt) {
    const files = evt.target.files;
    var file1 = evt.target.value;
    this.setState({
      btnDisabled: true,
      loading_overlay: true,
    }, () => {

      if (files && files[0]) {
        this.setState({
          file: files[0]
        })
      } else {
        this.setState({
          loading_overlay: false,
          btnDisabled: false,
          file: {},
        })
        $(".upload_success").css('display', 'none');
        $(".upload_error").css('display', 'none');
        $('.button_enable').removeAttr('disabled', 'disabled');
        return false;
      };

      var fileArray1 = file1.split(".");
      var extension1 = fileArray1[fileArray1.length - 1];

      if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color = "";
        document.getElementById("my_file_input").style.width = "85%";
        document.getElementById("picking_label").style.display = "none";
      } else {
        document.getElementById("my_file_input").style.width = "26%";
      }

      if (extension1 != "xlsx" && extension1 != "csv" && extension1 != "xls") {
        $(".upload_error").css("display", "block");
        $(".upload_success").css("display", "none");
      } else {
        $(".upload_success").css("display", "block");
        $(".upload_error").css("display", "none");
        $(".button_enable").removeAttr("disabled", "disabled");
      }

      this.setState({
        btnDisabled: false,
        loading_overlay: false,
      });
    });
  }

  change = (selectedOption) => {
    this.setState({
      selectedOption,
      selectedFileType: selectedOption.label,
      showInvalidProductItem: false,
      showInvalidTesterItem: false,
      showRowDataErrorProduct: false,
      showRowDataErrorTester: false,
      showInvalidBaseItem: false,
      showRowDataErrorBase: false,
      showRowDataError: false,
      showInvalidItem: false,
      showZoneConfigCard: false,
    });
    $(".upload_error").css("display", "none");
    $(".upload_success").css("display", "none");
    $(".fileControl").val("");
    $(".card_body_val").css("height", "300px")


    if (selectedOption.value === "without_invoice_header") {
      //this.fetchBinData();
      this.setState({
        showWithoutInvoiceHeader: true,
        showWithInvoiceHeader: false,
      });
    } else if (selectedOption.value === "supplier_invoice_header") {
      //this.fetchBaseData();
      this.setState({
        showWithoutInvoiceHeader: false,
        showWithInvoiceHeader: true,
      });
    } 

  };

  validateItem = (item) => {
    const { selectedFileType, validation } = this.state;
    const dataTypes = validation[selectedFileType];
  
    if (!dataTypes) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    const keyNames = Object.keys(dataTypes);
  
    // Check column count
    if (Object.keys(item).length != keyNames.length) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
  
    for (const key of keyNames) {
      const expectedType = dataTypes[key];
      const value = item[key];
  
      // Check for empty value
      if (value === undefined || value === null || value.toString().trim() === "") {
        this.setState({
          error: `Validation Error: '${key}' cannot be empty.`,
        });
        return false;
      }
  
      if (expectedType === "number" && isNaN(value)) {
        this.setState({
          error: `Validation Error: '${key}' must be a number.`,
        });
        return false;
      }
  
      if (expectedType === "string" && typeof value !== "string") {
        this.setState({
          error: `Validation Error: '${key}' must be a string.`,
        });
        return false;
      }
    }
  
    return true;
  };
  validateInvoicesSame = (items) => {
    const invoiceSet = new Set();
    for (const item of items) {
      const invoiceVal = item['Invoice'];
      if (invoiceVal !== undefined && invoiceVal !== null) {
        invoiceSet.add(invoiceVal.toString().trim());
      }
    }
  
    if (invoiceSet.size > 1) {
      this.setState({
        error: "Validation Error: Multiple invoice values found. Please ensure all rows use the same Invoice number",
      });
      return false;
    }
  
    return true;
  };
  
  handleFile() {
    /* Boilerplate to set up FileReader */
    $(".card_body_val").css("height", "300px")
    if (this.state.selectedOption === null || this.state.selectedOption === undefined ) {
      this.setState({
        responseModal: true,
        error: "Select at least one Master"
      });
      return false;
    }

    if (this.state.file.name === undefined || this.state.file.name === null) {
      this.setState({
        responseModal: true,
        error: "Select at least one File"
      });
      return false;
    }
    this.setState({
      loading: true,
      loading_overlay: true,
    });
    const ref = this;
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        dateNf: "YYYY-MM-DD"
      });

      var XL_row_object = XLSX.utils.sheet_to_row_object_array(
        wb.Sheets[wsname],
        { header: 1, blankRows: false }
      );
      var json_object = XL_row_object;

      var mandatory_field = false;
      var uploaded_file_header = json_object[0];

      if (this.state.selectedOption.value === "supplier_invoice_header") {
        var sample_file_header = Object.keys(this.state.supplier_invoice_header[0]);
      } else if (this.state.selectedOption.value === "without_invoice_header") {
        var sample_file_header = Object.keys(this.state.without_invoice_header[0]);
      }

      if (parseInt(uploaded_file_header.length) !== parseInt(sample_file_header.length)) {
        ref.setState({
          loading: false,
          responseModal: true,
          error: "Invalid Format",
          loading_overlay: false,
        });
        return false;
      }
      for (let i = 0; i < uploaded_file_header.length; i++) {
        if (uploaded_file_header[i] !== sample_file_header[i]) {
          ref.setState({
            loading: false,
            responseModal: true,
            error: "Invalid Format",
            loading_overlay: false,
          });
          return false;
        }
      }

      /* Update state */
      this.setState({ data: data, cols: make_cols(ws["!ref"]) }, () => {
        let invalidItems = this.state.data.filter(
          (item) => !this.validateItem(item)
        );
        let InvoiceConsistent = this.validateInvoicesSame(data);

        if (invalidItems.length > 0 || InvoiceConsistent == false) {
          this.setState({
            loading: false,
            loading_overlay: false,
            responseModal: true,
          });
          return;
        }

        if (this.state.selectedOption.value === "supplier_invoice_header") {
          if (invalidItems.length > 0) {
            this.setState({
              showWithInvoiceHeader:true,
              showWithoutInvoiceHeader:false,
            });
          }

          var arr = [];

          for (var i = 0; i < this.state.data.length; i++) {
            if ( this.state.data[i]["Product Condition"].trim() !== "Saleable" && this.state.data[i]["Product Condition"].trim() !== "Non Saleable") {
              ref.setState({
                loading: false,
                responseModal: true,
                error: "Invalid Product condition",
                loading_overlay: false,
              });
              return false;
            }
            var stock_types = 0
            if(this.state.data[i]["Product Condition"] == "Saleable"){
              stock_types= 0
            }
            else {
              stock_types = 1
            }
            var orderData = {};
            orderData["product_condition"] = this.state.data[i]["Product Condition"].trim();
            orderData["stock_type"] = stock_types ;
            orderData["bin_address"] = this.state.data[i]["Bin ID"];
            orderData["product_code"] = this.state.data[i]["Product Code"];
            orderData["mrp"] = this.state.data[i]["MRP"];
            orderData["quantity"] = parseFloat(this.state.data[i]["Return Qty"]);
            orderData["cost"] = parseFloat(this.state.data[i]["Return Rate"]);
            orderData["po_number"] = '';
            orderData["invoice_number"] = this.state.data[i]["Invoice"];
            orderData["asn_number"] = ""

            arr.push(orderData);
          }

          var arr_data = JSON.stringify(arr);

          const payload = {
            arr_data: arr,
            // location: this.state.selectedLocation,

          };
          API.post('/picking/addPurchaseReturns', { param: payload })

            .then((response) => {
              if (response.data.success == false) {
                this.setState({
                  loading: false,
                  failedData : response.data.data,
                  responseFailedData: response.data.message,
                });
                this.toggleFailed();
              } else {
                this.setState({
                  loading: false,
                  responseSuccessData: response.data.message,
                });
                this.toggle();
              }

              if (response.data.success_response.length > 0) {
                this.setState({
                  show_process_data: true,
                });
              } else {
                this.setState({
                  show_process_data: false,
                });
              }

              this.setState({ loading_overlay: false, })
              if (document.getElementById("my_file_input") !== null) {
                document.getElementById("my_file_input").style.color =
                  "transparent";
                document.getElementById("picking_label").style.display = "inline-block";
                document.getElementById("picking_label").innerHTML =
                  "Select and Upload Picksheet";
              }
              document.getElementById("my_file_input").style.width = "26%";
              $(".upload_error").css('display', 'none');
              $(".upload_success").css('display', 'none');
              /*this.fetchBaseData();*/
            })
            .catch(function (error) {
              if (document.getElementById("my_file_input") !== null) {
                document.getElementById("my_file_input").style.color =
                  "transparent";
                document.getElementById("picking_label").style.display = "inline-block";
                document.getElementById("picking_label").innerHTML =
                  "Select and Upload Picksheet";
              }
              document.getElementById("my_file_input").style.width = "26%";
              $(".upload_error").css('display', 'none');
              $(".upload_success").css('display', 'none');
            });
        }

        if (this.state.selectedOption.value === "without_invoice_header") {
          if (invalidItems.length > 0) {
            this.setState({
              showWithInvoiceHeader:false,
              showWithoutInvoiceHeader:true,
            });

          }

          var arr = [];
          
          for (var i = 0; i < this.state.data.length; i++) {
            if ( this.state.data[i]["Product Condition"].trim() !== "Saleable" && this.state.data[i]["Product Condition"].trim() !== "Non Saleable") {
              ref.setState({
                loading: false,
                responseModal: true,
                error: "Invalid Product condition",
                loading_overlay: false,
              });
              return false;
            }
            // <---- Move declaration inside loop
            var stock_types = 0
            if(this.state.data[i]["Product Condition"] == "Saleable"){
              stock_types= 0
            }
            else {
              stock_types = 1
            }
            var orderData = {};
            orderData["product_condition"] = this.state.data[i]["Product Condition"].trim();
            orderData["stock_type"] = stock_types ;
            orderData["bin_address"] = this.state.data[i]["Bin ID"];
            orderData["product_code"] = this.state.data[i]["Product Code"];
            orderData["mrp"] = this.state.data[i]["MRP"];
            orderData["quantity"] = parseFloat(this.state.data[i]["Return Qty"]);
            orderData["cost"] = parseFloat(this.state.data[i]["Return Rate"]);
            orderData["po_number"] = "";
            orderData["invoice_number"] = "";
            orderData["asn_number"] = ""

            arr.push(orderData);
          }

          var arr_data = JSON.stringify(arr);


          const payload = {
            arr_data: arr,
            // location: this.state.selectedLocation,

          };

          API.post('/picking/addPurchaseReturns', { param: payload })
            .then((response) => {
              if (response.data.success == false) {
                this.setState({
                  loading: false,
                  failedData : response.data.data,
                  responseFailedData: response.data.message,
                });
                this.toggleFailed();
              } else {
                this.setState({
                  loading: false,
                  responseSuccessData: response.data.message,
                });
                this.toggle();
              }

              if (response.data.success_response.length > 0) {
                this.setState({
                  show_process_data: true,
                });
              } else {
                this.setState({
                  show_process_data: false,
                });
              }

              this.setState({ loading_overlay: false, })
              if (document.getElementById("my_file_input") !== null) {
                document.getElementById("my_file_input").style.color =
                  "transparent";
                document.getElementById("picking_label").style.display = "inline-block";
                document.getElementById("picking_label").innerHTML =
                  "Select and Upload Picksheet";
              }
              document.getElementById("my_file_input").style.width = "26%";
              $(".upload_error").css('display', 'none');
              $(".upload_success").css('display', 'none');
            })
            .catch(function (error) {
              if (document.getElementById("my_file_input") !== null) {
                document.getElementById("my_file_input").style.color =
                  "transparent";
                document.getElementById("picking_label").style.display = "inline-block";
                document.getElementById("picking_label").innerHTML =
                  "Select and Upload Picksheet";
              }
              document.getElementById("my_file_input").style.width = "26%";
              $(".upload_error").css('display', 'none');
              $(".upload_success").css('display', 'none');
            });
        }

      });
    };

    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    return (

      <Col xl={12}>
        {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' />}
        <Card>
          <CardBody className="card_body_val" style={{ height: 100 }}>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={e => e.preventDefault()}>
              <div
                className="form__form-group col-xl-4"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-4"
                  style={{ display: "none", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Master
                </span>

                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Without Invoice"
                    value={selectedOption}
                    // value = {'without_invoice_header'}
                    onChange={this.change}
                    options={[

                      {
                        value: "supplier_invoice_header",
                        label: "With Supplier Invoice",
                      },
                      { value: "without_invoice_header", label: "Without Invoice" },

                    ]}
                  />
                </div>
              </div>

              <div
                className="form__form-group col-xl-5"
                style={{ marginBottom: "0px" }}
              >
                <div className="row">
                  <div
                    className="col-xl-12"
                    style={{ border: "1px solid #f2f4f7" }}
                  >
                    <input
                      style={{
                        paddingTop: 8,
                        height: 38,
                        color: "transparent",
                        width: "26%",
                        border: "0px",
                      }}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"

                      id="my_file_input"
                      onChange={this.handleChange}
                      ref={ref => this.fileInput = ref}
                    />
                    <label for="files" id="picking_label">
                      Select and Upload Purchase Return
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error"
                    >
                      {" "}
                      Invalid file format. Please select .xls, .xlsx, .csv file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={this.handleFile}
                    disabled={this.state.btnDisabled}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>
            </form>

            {this.state.showWithInvoiceHeader && (
              <div style={{ paddingLeft: "17px" }}>
                <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSV(
                      this.state.supplier_invoice_header,
                      "With_Supplier_Invoice_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                <div className="notes" style={{ paddingTop: "15px" }}>
                  <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                    <b>Note</b> : 1. All fields are mandatory.
                  </p>
                  <p
                    style={{
                      marginBottom: "13px",
                      fontSize: "15px",
                      paddingLeft: "46px",
                    }}
                  >
                    2. Product condition must be <b>Saleable or Non Saleable</b>
                  </p>
                </div>
              </div>
            )}

            {this.state.showWithoutInvoiceHeader && (
              <div style={{ paddingLeft: "17px" }}>
                <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSV(
                      this.state.without_invoice_header,
                      "Without_Invoice_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                <div className="notes" style={{ paddingTop: "15px" }}>
                  <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                    <b>Note</b> : 1. All fields are mandatory.
                  </p>
                  <p
                    style={{
                      marginBottom: "13px",
                      fontSize: "15px",
                      paddingLeft: "46px",
                    }}
                  >
                    2. Product condition must be <b>Saleable or Non Saleable</b>
                  </p>
                </div>
              </div>
            )}

            
          </CardBody>

          </Card>
        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.responseSuccessData} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggle1}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h3>{this.state.failedData} </h3><br />
            <h4>{this.state.responseFailedData}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleFailed}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.successCreatedMessage}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccesstoggleCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal isOpen={this.state.responseModal} toggle={this.responseModalToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.responseModalToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.error}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.responseModalToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));